@if (showLoader()) {
    <app-loader></app-loader>
}

<div #cycleCountGridPage class="cycle-count-grid-page" [style.height.px]="gridPageHeight()">
    @if (gridConfig(); as config) {
        <inavista-grid #cycleCountGrid
            [config]="config"
            [actionIcons]="actionIcons()"
            (actionIconClick)="onActionIconClick($event)"
            (hyperlinkClick)="onHyperlinkClick($event)"
            (toolbarActionClick)="onToolbarActionClick($event)"
            (rowCommit)="onRowCommit($event)"
            (exportRequested)="onExportRequested($event)" />
    }
</div>

<!-- Start Date while a row is open (CycleCount_StartDate edit): from today on, never empty, as before. -->
<ng-template #startDateEditor let-draft="draft" let-setRawValue="setRawValue">
    <inavista-date-picker placeholder="Select start date..." format="d MMM, yyyy" [clearable]="false" [min]="today"
        [value]="draft?.startDate || null" (valueChange)="setRawValue($event)" />
</ng-template>

@if (cycleCountPopup(); as popup) {
    <app-cycle-counts-popup
        [cycleCountData]="popup.row"
        [cycleCountId]="popup.cycleCountId"
        [showComments]="popup.showComments"
        [tab]="popup.tab"
        (onClose)="onCycleCountClose()">
    </app-cycle-counts-popup>
}

@if (showAddPopup()) {
    <app-cycle-counts-add-popup
        (refreshMainGrid)="refresh()"
        (onClose)="showAddPopup.set(false)">
    </app-cycle-counts-add-popup>
}
